<template>
    <v-btn @click="onClick"
           content="Custom Layouts"
           v-tippy="{placement: 'right', boundary: 'window'}"
           :disabled="isDisabled"
    >
        <v-icon class="material-symbols-outlined">splitscreen_top</v-icon>
    </v-btn>
</template>

<script>

import { mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],

    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image']),
        isDisabled() {
            return !this.canUseColorGradingTools || this.blockLoading || !this.image || this.IDT.initial
        }
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setLeftColumn', 'layouts')
        },
    },
};
</script>
